/**
 * Browser session access for non-auth modules.
 * Wraps Supabase Auth session APIs so feature code does not import the client directly.
 */

import { supabase } from "@/integrations/supabase/client";
import type { AuthError, Session, User } from "@supabase/supabase-js";

export async function getClientSession(): Promise<{
  data: { session: Session | null };
  error: AuthError | null;
}> {
  const result = await supabase.auth.getSession();
  return result;
}

export async function getClientUser(): Promise<{
  data: { user: User | null };
  error: AuthError | null;
}> {
  const result = await supabase.auth.getUser();
  return result;
}

export async function refreshClientSession(): Promise<{
  data: { session: Session | null };
  error: AuthError | null;
}> {
  const result = await supabase.auth.refreshSession();
  return result;
}

export async function getAccessToken(): Promise<string | null> {
  const { data } = await getClientSession();
  return data.session?.access_token ?? null;
}

/** Clear the local browser session without calling the remote logout endpoint. */
export function signOutClientLocal(): Promise<{ error: AuthError | null }> {
  return supabase.auth.signOut({ scope: "local" });
}
